'use strict';

( function( $ ) {
	class Pagination {
		constructor( $component ) {
			this.$pagination = $component;
			this.$select = $component.find( '[data-pagination="select"]' );

			this.init = this.init.bind( this );

			this.init();
		}

		init() {
			this.$select.on( 'change', e => {
				window.location.href = e.target.value;
			} );
		}
	}

	$.fn.pagination = function() {
		this.each( function() {
			new Pagination( $( this ) );
		} );
	};

	$( '[data-pagination="component"]' ).pagination();
}( jQuery ) );

const filterToggle = $ => {
	const $filters = $( '#hidden-filters' );
	const $toggle = $( '#filter-toggle' );
	const $wrapper = $( '#hidden-filters-wrapper' );

	const toggleFilters = () => {
		if ( $wrapper.hasClass( 'opening' ) || $filters.hasClass( 'closing' ) ) {
			return;
		}

		if ( $wrapper.hasClass( 'opened' ) ) {
			closeFilters();
		}

		if ( $wrapper.hasClass( 'closed' ) ) {
			openFilters();
		}
	};

	const openFilters = () => {
		$wrapper
			.css( {
				display: 'block',
				height: 0
			} )
			.removeClass( 'closed' )
			.addClass( 'opening' );

		const height = $wrapper.get( 0 ).scrollHeight;

		$wrapper.animate( {
			height
		}, 400, () => {
			$wrapper
				.removeClass( 'opening' )
				.addClass( 'opened' )
				.attr( 'style', '' );

			$toggle
				.attr( 'aria-expanded', 'true' )
				.text( 'Show Fewer Filters' );
		} );
	};

	const closeFilters = () => {
		const height = $wrapper.get( 0 ).scrollHeight;

		$wrapper
			.css( {
				height
			} )
			.removeClass( 'opened' )
			.addClass( 'closing' )
			.animate( {
				height: 0
			}, 400, () => {
				$wrapper
					.removeClass( 'closing' )
					.addClass( 'closed' )
					.attr( 'style', '' );

				$toggle
					.attr( 'aria-expanded', 'false' )
					.text( 'Show More Filters' );
			} );
	};

	return {
		init() {
			if ( $filters.length < 1 ) {
				return;
			}

			this.bind();
		},
		bind() {
			$toggle.on( 'click', () => {
				toggleFilters();
			} );
		}
	};
};

filterToggle( jQuery ).init();

( function( $ ) {
	function youtubeParser( url ) {
		const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
		const match = url.match( regExp );
		return ( match && match[ 7 ].length === 11 ) ? match[ 7 ] : false;
	}

	$( '#video-modal' ).on( 'show.bs.modal', function( e ) {
		const $btn = $( e.relatedTarget );
		const $content = $( '#video-modal-body' );
		const url = $btn.attr( 'href' );
		const ytid = youtubeParser( url );
		const src = 'https://www.youtube.com/embed/' + ytid + '?autoplay=1';

		const $embed = $( '<div/>', {
			class: 'embed-responsive embed-responsive-16by9'
		} );

		const $iframe = $( '<iframe/>', {
			class: 'embed-responsive-item',
			src
		} );

		$iframe
			.attr( 'allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' )
			.attr( 'allowfullscreen', true );

		$embed.append( $iframe );

		$content.append( $embed );
	} );

	$( '#video-modal' ).on( 'hide.bs.modal', function( e ) {
		$( '#video-modal-body' ).html( '' );
	} );

	$( '#video-embed-modal' ).on( 'show.bs.modal', function( e ) {
		const $btn = $( e.relatedTarget );
		const $content = $( '#video-embed-modal-body' );
		const $iframe = $btn.attr( 'data-embedcode' );
		console.log($iframe);

		const $embed = $( '<div/>', {
			class: 'embed-responsive embed-responsive-16by9'
		} );

		$embed.append( $iframe );

		$content.append( $embed );
	} );

	$( '#video-embed-modal' ).on( 'hide.bs.modal', function( e ) {
		$( '#video-embed-modal-body' ).html( '' );
	} );
} )( jQuery );

const filterSearch = $ => {
	return {
		init() {
			this.bind();
		},
		bind() {
			$( '.filter-form #filter-submit' ).on( 'click', function(e) {
				e.preventDefault();

				var types = [];
				$.each($("input[name='type']:checked"), function(){
					types.push($(this).val());
				});

				// Defaults
				if (types.length === 0) {
					types = $(this).data('default-types');
				}

				var issues = [];
				$.each($("input[name='issue']:checked"), function(){
					issues.push($(this).val());
				});

				$( '#card-feed' ).html(`
					<div class="spinner-wrapper" id="spinner">
					  <div class="spinner-border" role="status">
						<span class="sr-only">Loading...</span>
					  </div>
					</div>
				`);

				// Update URL
				window.history.pushState( '', '', '?types-filter=' + types + '&issues-filter=' + issues );

				$.ajax( {
					type: 'POST',
					url: '/wp-admin/admin-ajax.php',
					dataType: 'html',
					data: {
						'action' : 'get_cards',
						'types' : types,
						'issues' : issues,
					},
					success: function( data ) {
						if (!$.trim(data)){
							$( '#card-feed' ).html(`
								<div class="no-results-wrapper"><p>No Results Found</p></div>
							`);
						} else {
							$( '#card-feed' ).html( data );
						}
					},
					error: function( data ) {
						console.log( data );
					}
				} );
			} );


			$( document ).on( 'click', '.card-pagination .pagination-link', function(e) {
				e.preventDefault();

				var school_page = $(this).attr( 'data-school-page' );

				$('html, body').animate({
					scrollTop: $( '#card-feed' ).offset().top
				}, 500);

				var types = [];
				$.each($("input[name='type']:checked"), function(){
					types.push($(this).val());
				});
				var issues = [];
				$.each($("input[name='issue']:checked"), function(){
					issues.push($(this).val());
				});

				// Defaults
				if (types.length === 0) {
					types = $( '.filter-form #filter-submit' ).data('default-types');

				}

				$( '#card-feed' ).html(`
					<div class="spinner-wrapper" id="spinner">
					  <div class="spinner-border" role="status">
						<span class="sr-only">Loading...</span>
					  </div>
					</div>
				`);

				$.ajax( {
					type: 'POST',
					url: '/wp-admin/admin-ajax.php',
					dataType: 'html',
					data: {
						'action' : 'get_cards',
						'school_page' : school_page,
						'types' : types,
						'issues' : issues,
					},
					success: function( data ) {
						if (!$.trim(data)){
							$( '#card-feed' ).html(`
								<div class="no-results-wrapper"><p>No Results Found</p></div>
							`);
						} else {
							$( '#card-feed' ).html( data );
						}
					},
					error: function( data ) {
						console.log( data );
					}
				} );
			} );

			$( document ).on( 'change', '.card-pagination .pagination-select', function(e) {
				e.preventDefault();

				var school_page = $(this).children(':selected').attr('data-school-page');

				$('html, body').animate({
					scrollTop: $( '#map-feed' ).offset().top
				}, 500);

				var types = [];
				$.each($("input[name='type']:checked"), function(){
					types.push($(this).val());
				});
				var issues = [];
				$.each($("input[name='issue']:checked"), function(){
					issues.push($(this).val());
				});

				// Defaults
				if (types.length === 0) {
					types = $( '.filter-form #filter-submit' ).data('default-types');

				}

				$( '#school-feed' ).html(`
					<div class="spinner-wrapper" id="spinner">
					  <div class="spinner-border" role="status">
						<span class="sr-only">Loading...</span>
					  </div>
					</div>
				`);

				$.ajax( {
					type: 'POST',
					url: '/wp-admin/admin-ajax.php',
					dataType: 'html',
					data: {
						'action' : 'get_cards',
						'school_page' : school_page,
						'types' : types,
						'issues' : issues,
					},
					success: function( data ) {
						if (!$.trim(data)){
							$( '#card-feed' ).html(`
								<div class="no-results-wrapper"><p>No Results Found</p></div>
							`);
						} else {
							$( '#card-feed' ).html( data );
						}
					},
					error: function( data ) {
						console.log( data );
					}
				} );
			} );
		}
	};
};

filterSearch( jQuery ).init();


const dropdownHover = $ => {
	return {
		init() {
			this.bind();
		},
		bind() {
			$(document).ready(function(){
				console.log('test');
				$(".dropdown").hover(function(){
					console.log('hover');
					var dropdownMenu = $(this).children(".dropdown-menu");
					dropdownMenu.toggleClass("show");
				});
			});
		}
	};
};

dropdownHover( jQuery ).init();

const updateLinks = $ => {
	return {
		init() {
			this.bind();
		},
		bind() {
			$(document).ready(function(){
				$("section.report-details a").each(function() {
					$(this).attr("target","_blank");
				});
			});
		}
	};
};

updateLinks( jQuery ).init();

const changeAddressCollapse = $ => {

	const togglePanel = () => {
		console.log('clicked');
		let panel = $( ".district-search .search-input" );
		console.log(panel.css('max-height'));

		if (panel.css('max-height') || panel.css('max-height') !== 'none') {
			panel.css('max-height', 'none');
		} else {
			panel.css('max-height', '0px');
		}
	}

	return {
		init() {
			this.bind();
		},
		bind() {
			let searchButton = $( ".search-reset .btn-reset");
			searchButton.click(function () {

				togglePanel();
			});
		}
	};
}

changeAddressCollapse( jQuery ).init();
